/** @format */

import LiveEdithTextHighLighter from '../../../liveEditHighlighterstyles/liveEdithTextHighLighter.component';
import LiveEditImageHighLighter from '../../../liveEditHighlighterstyles/liveEditImageHighLighter.component';
import {
  FooterContainer,
  FooterSocialMediaLinksContainer,
} from './footer.style';
import ProImg from '../../Template1/Footer/profile.jpg';

export default function FooterT3({ data }) {
  return (
    <footer id='footer' className="footer py-4">
      <div className="container">
        <div className="row align-items-center pt-2">
          <div className="col-12 text-center mb-4">
            <h2 className="fw-bold text-white text-uppercase">
              <LiveEdithTextHighLighter section="footer" type="text2">
                <div dangerouslySetInnerHTML={{ __html: data?.footer?.text2, }}></div>
              </LiveEdithTextHighLighter>
            </h2>
            <h6>
              <LiveEdithTextHighLighter section="footer" type="text3">
                <div dangerouslySetInnerHTML={{ __html: data?.footer?.text3, }}></div>
              </LiveEdithTextHighLighter>
            </h6>
            <LiveEdithTextHighLighter section="footer" type="text7">
              <p dangerouslySetInnerHTML={{ __html: data?.footer?.text7, }}></p>
            </LiveEdithTextHighLighter>
          </div>
        </div>

        <div className="row pt-2">
          <div className="col-12 col-md-4 text-center mb-3 mb-md-0">
            <div className="row pt-0">
              <div className="col-12">
                <img src={'/public/' + data?.footer?.image2} alt="Agent Image" className="img-fluid" style={{ minWidth: '100%' }} />
              </div>
              <div className="col-12 p-4">
                <LiveEditImageHighLighter section={'footer'} type="img">
                  {data?.footer.islogoVisible && <img src={'/public/' + data?.footer?.image} alt="logo" className="img-fluid logo" />}
                </LiveEditImageHighLighter>
                <div className="social-icons">
                  {data?.footer?.socialmedialinks.map((data, i) => (
                    <a href={data.link} className="image_wrapper" key={i}>
                      <img src={`/public/${data.image}`} alt="socialMediaLinks" />
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-8">
            <div className="row pt-0">
              <div className="col-12 d-flex justify-content-start py-3">
                <i className="pe-3 pt-1">
                  <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C8.686 2 6 4.686 6 8C6 12.7 12 21 12 21C12 21 18 12.7 18 8C18 4.686 15.314 2 12 2ZM8 8C8 5.791 9.791 4 12 4C14.209 4 16 5.791 16 8C16 10.757 13.434 15.122 12 17.219C10.566 15.122 8 10.757 8 8ZM12 10C10.895 10 10 9.105 10 8C10 6.895 10.895 6 12 6C13.105 6 14 6.895 14 8C14 9.105 13.105 10 12 10Z" fill="#ffffff"></path>
                  </svg>
                </i>
                <span>
                  <p className="text-title mb-1">Address</p>
                  <a href="#">
                    <LiveEdithTextHighLighter section="footer" type="text6">
                      <div dangerouslySetInnerHTML={{ __html: data?.footer?.text6, }}></div>
                    </LiveEdithTextHighLighter>
                  </a>
                </span>
              </div>
              <div className="col-12 col-md-6 d-flex justify-content-start py-3"><i className="pe-3 pt-1"><svg width="30" height="25"
                viewBox="0 0 30 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M10.7964 8.1207H19.2036V8.7279C19.2036 10.8195 20.9082 12.5259 23.001 12.5259H24.741L25.2852 20.7051C25.3776 22.1235 24.2868 23.2719 22.8822 23.2719H7.0032C5.5944 23.2719 4.5084 22.1085 4.6002 20.7039C4.782 17.9895 4.9152 15.2313 5.154 12.5265H6.9996C9.0918 12.5265 10.797 10.8207 10.797 8.7285V8.1207H10.7964ZM11.46 16.5807C11.46 14.6565 13.0188 13.0977 14.943 13.0977C16.8666 13.0977 18.4254 14.6571 18.4254 16.5807C18.4254 18.5055 16.8678 20.0631 14.943 20.0631C13.02 20.0637 11.46 18.5043 11.46 16.5807ZM14.943 12.0381C12.4344 12.0381 10.4004 14.0721 10.4004 16.5807C10.4004 19.0887 12.435 21.1233 14.943 21.1233C17.4486 21.1233 19.485 19.0869 19.485 16.5807C19.485 14.0727 17.451 12.0381 14.943 12.0381ZM9.0846 4.8363C8.22 4.8363 7.512 5.5443 7.512 6.4089V8.7285C7.512 9.0093 7.2804 9.2415 6.999 9.2415H1.5726C1.2906 9.2415 1.0596 9.0111 1.0596 8.7285V6.9285C1.0596 6.4797 1.1628 6.0945 1.3902 5.7069C1.896 4.8465 2.7294 4.1013 3.795 3.4749C9.279 0.2517 20.7192 0.2523 26.2044 3.4749C27.2706 4.1013 28.104 4.8465 28.6098 5.7069C28.8354 6.0921 28.9398 6.4815 28.9398 6.9285V8.7285C28.9398 9.0111 28.71 9.2415 28.4268 9.2415H23.0004C22.719 9.2415 22.4874 9.0093 22.4874 8.7285V6.4089C22.4874 5.5425 21.7806 4.8363 20.9148 4.8363H9.0846ZM8.571 6.4089C8.571 6.1263 8.8026 5.8965 9.0846 5.8965H20.9154C21.1968 5.8965 21.429 6.1275 21.429 6.4089V8.7285C21.429 9.5943 22.1352 10.3017 23.001 10.3017H28.4274C29.292 10.3017 30 9.5931 30 8.7285V6.9285C30 6.2835 29.8464 5.7291 29.5206 5.1729C28.9188 4.1493 27.9564 3.2799 26.7384 2.5641C20.9214 -0.8547 9.0798 -0.8547 3.2622 2.5641C2.0436 3.2799 1.0812 4.1487 0.48 5.1729C0.153 5.7291 0 6.2835 0 6.9279V8.7279C0 9.5925 0.7092 10.3011 1.5726 10.3011H6.999C7.8648 10.3011 8.571 9.5937 8.571 8.7279V6.4089ZM9.7368 7.5915V8.7285C9.7368 10.2387 8.5092 11.4669 6.999 11.4669H4.6686C4.3914 11.4669 4.164 11.6799 4.1412 11.9511C3.8892 14.8347 3.7386 17.7435 3.5448 20.6331C3.4116 22.6425 4.989 24.3315 7.0032 24.3315H22.8822C24.882 24.3315 26.475 22.6575 26.3406 20.6343L25.7622 11.9607C25.7436 11.6811 25.5102 11.4675 25.2342 11.4675L23.001 11.4663C21.4902 11.4663 20.2632 10.2375 20.2632 8.7279V7.5909C20.2632 7.2981 20.0262 7.0611 19.7334 7.0611H10.2666C9.9738 7.0611 9.7368 7.2987 9.7368 7.5915Z"
                  fill="#ffffff"></path>
              </svg></i><span>
                  <p className="text-title mb-1">Phone number</p><a href="tel:0000000000">
                    <LiveEdithTextHighLighter section="footer" type="text4">
                      <div dangerouslySetInnerHTML={{ __html: data?.footer?.text4, }}></div>
                    </LiveEdithTextHighLighter>
                  </a>
                </span>
              </div>
              <div className="col-12 col-md-6 d-flex justify-content-start py-3"><i className="pe-3 pt-1"><svg width="30" height="19"
                viewBox="0 0 30 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M2 0C0.903517 0 0 0.903517 0 2V16.6667C0 17.7631 0.903517 18.6667 2 18.6667H28C29.0965 18.6667 30 17.7631 30 16.6667V2C30 0.903517 29.0965 0 28 0H2ZM2.4375 1.33333H27.5625L15.6458 11.4896C15.3389 11.7512 14.6612 11.7512 14.3542 11.4896L2.4375 1.33333ZM1.33333 2.13542L10.1979 9.6979L1.33333 16.5729V2.13542ZM28.6667 2.13542V16.5729L19.8021 9.6979L28.6667 2.13542ZM11.2396 10.5833L13.4896 12.5C14.3543 13.2369 15.6457 13.2369 16.5104 12.5L18.7604 10.5833L27.4687 17.3333H2.53125L11.2396 10.5833Z"
                  fill="#ffffff"></path>
              </svg></i><span>
                  <p className="text-title mb-1">E-Mail</p><a href="#">
                    <LiveEdithTextHighLighter section="footer" type="text5">
                      <div dangerouslySetInnerHTML={{ __html: data?.footer?.text5, }}></div>
                    </LiveEdithTextHighLighter>
                  </a>
                </span>
              </div>
              <div className="col-12 mt-5 mb-4">
                <p className="small mb-3">
                  <LiveEdithTextHighLighter section="footer" type="description">
                    <div dangerouslySetInnerHTML={{ __html: data?.footer?.description, }}></div>
                  </LiveEdithTextHighLighter>
                </p>
                <a className="small text-secondary" href="https://agentshades.com/login" target='_blank'>🗝️ Agent Login</a>
              </div>
            </div>
          </div>
        </div>

        <div className="row pt-2">
          <div className="col-12 text-center">
            <p className="small">Powered by: <strong>AgentShades</strong></p>
            <p className="small">Copyright © 2024 | <a href="#" className="text-decoration-none">Policy</a></p>
          </div>
        </div>
      </div>
    </footer>
  );
}
